export default "__VITE_ASSET__DhRopoPs__"